import { Select, SelectProps, OutlinedInput, styled } from '@mui/material'
import { forwardRef } from 'react'

import { CategoryOpt } from './common'

const SelectInput = styled(OutlinedInput)(() => ({
  borderRadius: 0,
  minWidth: 355,
}))

interface Props extends SelectProps {
  opts?: CategoryOpt[]
  isPicked?: boolean
  hideEmptyCate?: boolean
  testid: string
}

const ItemsMultiSelector = forwardRef<HTMLSelectElement, Props>((props, ref) => {
  const { opts, isPicked = true, hideEmptyCate = true, testid, ...rest } = props

  return (
    <Select
      multiple
      native
      input={<SelectInput margin="dense" inputRef={ref} />}
      inputProps={{ style: { height: 400, backgroundColor: 'white' } }}
      {...rest}
      data-testid={testid}
    >
      {opts
        ?.filter((c) => !hideEmptyCate || c.items.filter((i) => i.picked === isPicked).length > 0)
        .map(({ key, name, items }) => (
          <optgroup key={key} label={name}>
            {items.map(
              ({ name, key, picked }) =>
                picked === isPicked && (
                  <option key={key} value={key}>
                    {name}
                  </option>
                ),
            )}
          </optgroup>
        ))}
    </Select>
  )
})

ItemsMultiSelector.displayName = 'ItemsMultiSelector'
export default ItemsMultiSelector
